import React from 'react';

function Hero() {
  return (
    <div id="Hero" className="hero-section text-center" >
      {/* Banner Image */}
      <img
        src="/banner-image.jpeg"
        alt="Banner"
        style={{ width: '100%', height: 'auto' }}
      />
    </div>
  );
}

export default Hero;